import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import * as languageLibrary from '../../../../../../services/language'
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DynamicService } from 'src/app/services/dynamic.service';
import { token } from '../roles.component';
import { MasterService } from 'src/app/services/master.service';
import { MessageService } from 'src/app/services/message.service';
import { StoreService } from 'src/app/services/store.service';
import { ContactWarranty } from 'src/app/models/contact-warranty.model';
import { clean } from 'src/app/utils/numeric';
import { Subscription } from 'rxjs';

export interface Product {
    name: string;
    id: number;
}
@Component({
    selector: '[role-warranty]',
    templateUrl: './role-warranty.component.html',
    styleUrls: ['./role-warranty.component.scss'],
    standalone: false
})
export class RoleWarrantyComponent implements OnInit {

    protected contactId: number

    protected contactRoleId: number = 0

    protected words = languageLibrary.language

    protected language: string = 'EN'

    public warrantyInformation = new FormGroup({
        id: new FormControl<number | null>(null),
        contactId: new FormControl<number | null>(null, [Validators.required]),
        dealerCost: new FormControl<string | null>(null),
        sellingPrice: new FormControl<string | null>(null),
        deductible: new FormControl<string | null>(null),
        partsPercentage: new FormControl<string | null>(null),
        laborPercentage: new FormControl<string | null>(null),
        warrantedTime: new FormControl<string | null>(null),
        warrantedMiles: new FormControl<string | null>(null),
        warrantedComponents: new FormControl<string | null>(null),
        buyersObligation: new FormControl<string | null>(null),
        contractUsed: new FormControl<number | null>(null),
        productId: new FormControl<number | null>(null),
        productName: new FormControl<string | null>(null)
    })

    protected dataIn: string;

    public id: number = 0;

    public calledFrom: string;

    public corporateProducts: Product[];

    public contactWarrantyProducts: ContactWarranty[];

    private subscriptions: Subscription[] = []

    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private inject: Injector, private serv: DynamicService, private store: StoreService, private fb: FormBuilder) {

    }

    deactivateRole() {
        this.serv.outputFromDynamicComponent({ action: "deactivate", contactRoleId: this.contactRoleId });
    }


    ngOnInit(): void {
        this.dataIn = this.inject.get(token);
        this.contactId = this.dataIn['contactId']
        this.contactRoleId = this.dataIn['contactRoleId']
        this.calledFrom = this.dataIn['calledFrom']

        this.warrantyInformation.get('contactId').setValue(this.contactId || null)

        this.getWarranty()
        this.getCorporateProducts()

        this.subscriptions.push(this.warrantyInformation.get('productName').valueChanges.subscribe(value => {
            this.warrantyInformation.get('productId').setValue(null)

            const product = this.corporateProducts.find(p => p.name === value)
            if (!product) {
                return
            }

            this.warrantyInformation.get('productId').setValue(product.id)
        }))
    }

    ngOnDestroy(): void {
        this.resetInformation()
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }

    public getWarranty() {
        this.contactWarrantyProducts = []
        this.loading = true

        this.master.get(`contacts/${this.contactId}/warranty`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (res.data.contactWarranty.length === 0) {
                return
            }

            this.contactWarrantyProducts = res.data.contactWarranty
        })
    }

    public getCorporateProducts() {
        this.corporateProducts = []

        this.master.get(`corporation/products?category=warranty`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (!res.data.products || res.data.products.length == 0) {
                return
            }

            this.corporateProducts = res.data.products
        })
    }

    public saveWarranty() {
        if (this.warrantyInformation.invalid) {
            return
        }

        if (this.id <= 0) {
            this.createWarranty()
            return
        }

        this.modifyWarranty()
    }

    createWarranty() {
        const payload = JSON.parse(JSON.stringify(this.warrantyInformation.value))
        delete(payload['id'])
        if (payload['warrantedMiles']) {
            payload['warrantedMiles'] = clean(payload['warrantedMiles'])
        }
        if (payload['dealerCost']) {
            payload['dealerCost'] = clean(payload['dealerCost'])
        }
        if (payload['sellingPrice']) {
            payload['sellingPrice'] = clean(payload['sellingPrice'])
        }
        if (payload['deductible']) {
            payload['deductible'] = clean(payload['deductible'])
        }

        this.master.post(`contacts/${this.contactId}/warranty`, { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.resetInformation()
            this.contactWarrantyProducts = res.data.contactWarranty

            if (this.calledFrom == "contactAdvancedSearch") {
                this.serv.outputFromDynamicComponent({ action: "setupSaved", setupSaved: true, type: "warranty" })
            }
        })
    }

    modifyWarranty() {
        const payload = JSON.parse(JSON.stringify(this.warrantyInformation.value))
        delete(payload['id'])
        if (payload['warrantedMiles']) {
            payload['warrantedMiles'] = clean(payload['warrantedMiles'])
        }
        if (payload['dealerCost']) {
            payload['dealerCost'] = clean(payload['dealerCost'])
        }
        if (payload['sellingPrice']) {
            payload['sellingPrice'] = clean(payload['sellingPrice'])
        }
        if (payload['deductible']) {
            payload['deductible'] = clean(payload['deductible'])
        }

        this.master.put(`contacts/${this.contactId}/warranty/${this.id}`, { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.resetInformation()
            this.contactWarrantyProducts = res.data.contactWarranty

            if (this.calledFrom == "contactAdvancedSearch") {
                this.serv.outputFromDynamicComponent({ action: "setupSaved", setupSaved: true, type: "warranty" })
            }
        })
    }

    deleteWarranty() {
        this.master.discard(`contacts/${this.contactId}/warranty/${this.id}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.contactWarrantyProducts = res.data.contactWarranty
            const btn = (document.getElementById('btn-close-modal-delete-product') as HTMLButtonElement)
            if (btn) { btn.click() }

            this.resetInformation()
        })
    }

    resetInformation() {
        this.warrantyInformation.reset({
            contactId: this.contactId
        })
        this.id = null
    }

    setInformation(info) {
        this.setId(info['id'])

        this.warrantyInformation.setValue({
            id: info['id'],
            contactId: info['contactId'],
            productId: info['productId'],
            productName: info['product']['name'],
            dealerCost: info['dealerCost'],
            sellingPrice: info['sellingPrice'],
            deductible: info['deductible'],
            partsPercentage: info['partsPercentage'],
            laborPercentage: info['laborPercentage'],
            warrantedTime: info['warrantedTime'],
            warrantedMiles: info['warrantedMiles'],
            warrantedComponents: info['warrantedComponents'],
            buyersObligation: info['buyersObligation'],
            contractUsed: info['contractUsed']
        }, {emitEvent: false})
    }

    setId(id) {
        this.id = id
    }

}
